import React, {useEffect, useState} from 'react';
import {classes, style} from './doppe-viewer-default-notification-toast.st.css';
import {
    DoppeViewerDefaultNotificationSettings
} from '../doppe-viewer-default-notification-settings/doppe-viewer-default-notification-settings';
import {useDoppeViewerLocales} from '../../client/doppe-viewer-locales/doppe-viewer-locales';
import {DoppeViewerModalPanel, DoppeViewerModalPanelLayout} from '../doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {CommonClasses} from '@wix/devzai-common-client';

export const DoppeViewerDefaultNotificationToast = React.memo(function DoppeViewerDefaultNotificationContent(props: DoppeViewerDefaultNotificationContent.Props) {
    const {
        message = '',
        onClose,

        className,
        ...htmlAttributes
    } = props;

    const [_countdown, setCountdown] = useState(5);

    const normalizedMessage = message.trim();

    useEffect(() => {

        const countdownInterval = setInterval(() => {
            setCountdown(countdown => {
                const updatedCountdown = countdown - 1;

                if (updatedCountdown === 0) {
                    clearInterval(countdownInterval);
                    onClose?.();
                }

                return updatedCountdown;
            })
        }, 1000);

        return () => {
            clearInterval(countdownInterval)
        }
    }, []);

    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <DoppeViewerModalPanel
            {...htmlAttributes}
            className={style(classes.root, className)}
            mobileLayout={DoppeViewerModalPanelLayout.Toast}
            desktopLayout={DoppeViewerModalPanelLayout.Toast}
        >
            <div
                className={style(classes.contentRow, {})}
            >
                {
                    normalizedMessage !== '' ?
                        (
                            <div
                                className={style(classes.additionalMessage, {})}
                            >
                                {normalizedMessage}
                            </div>
                        ) :
                        null
                }
            </div>
            <button
                className={style(classes.cancelButton, {}, CommonClasses.button)}
                onClick={onClose}
            >
                {doppeViewerLocales['autoRedirectBannerRedirectingCloseText']}
            </button>
        </DoppeViewerModalPanel>

    );
});

export namespace DoppeViewerDefaultNotificationContent {

    export interface Props extends DoppeViewerDefaultNotificationSettings, React.HTMLAttributes<any> {
    }
}
